import { ModelBase } from 'store/model-base';

export class CmsNowReturnExchange extends ModelBase {
    public static storeName: string = 'cmsNowReturnExchange';

    public deviceDamageDetails: CmsDeviceDamageDetails;
    public eligibilityFailed: CmsNowErrorModal;
    public claimEligibilityFailed: CmsNowErrorModal;
    public returnExchangeDetails: CmsReturnExchangeDetails;
    public returnDetails: CmsReturnDetails;
    public inStoreReturnExchangeDetails: CmsInStoreReturnExchangeDetails;
}
